// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { formatDate } from '../../../utils/formatCalendar';
import { cascadingStatuses } from '../statuses';
import { Update } from '@mui/icons-material';

export default class PayoutInstancesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'payoutInstances';
        this.Server = this.props.context.getState().server.payoutInstances;
        this.MenuDisplayType = 'menu';
        this.searchFields = [
            'uuid',
            'orderUuid',
            'merchantTransactionId',
            'gatewayTransactionId'
        ];
        // this.showTotalRow = true;
        this.exportButton = true;

        this.hasCustomLogicOnMount = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'uuid',
                    label: 'uuid',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'merchantTerminalId',
                    label: 'merchantTerminal',
                    object: 'merchantTerminal',
                    show: 'name+merchantTerminalUuid',
                    from: 'publicMerchantTerminals',
                    alignRight: false,
                    cell: 'Select',
                    filterCell: 'Context',
                    filterBy: 'publicMerchantTerminals',
                    displayGrid: true
                },
                {
                    id: 'terminalGatewayId',
                    label: 'terminalGateway',
                    object: 'terminalGateway',
                    show: 'name',
                    nestedObject: 'gateway',
                    from: 'publicGateways',
                    alignRight: false,
                    cell: 'Select',
                    filterCell: 'Context',
                    filterBy: 'publicGateways',
                    filterField: 'terminalGateway.gateway',
                    displayGrid: true
                },
                {
                    id: 'merchantTransactionId',
                    label: 'merchantTransaction',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'p2pMethods',
                    label: 'p2pMethods',
                    object: 'merchantTerminal',
                    alignRight: false,
                    disableEditor: true,
                    displayGrid: false,
                    displayDialogDetails: true,
                    details: 'Array'
                },
                {
                    id: 'orderUuid',
                    label: 'orderUuid',
                    alignRight: false,
                    cell: 'Text',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'cascadingStatus',
                    label: 'cascadingStatus',
                    alignRight: false,
                    cell: 'State',
                    items: Object.keys(cascadingStatuses),
                    displayGrid: true,
                    disableEditor: true,
                },
                {
                    id: 'amount',
                    label: 'amount',
                    alignRight: false,
                    cell: 'Amount',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'commissionAgentJson',
                    label: 'commissionAgentJson',
                    // showAs: 'agent.name',
                    alignRight: false,
                    cell: 'CommissionsTotal',
                    from: 'publicCommissions',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true,
                    // extraRender: (row) => getTotalCommission('totalAgentCommission', row)
                },
                {
                    id: 'commissionMerchantJson',
                    label: 'commissionMerchantJson',
                    alignRight: false,
                    cell: 'CommissionsTotal',
                    from: 'publicCommissions',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true,
                },
                {
                    id: 'commissionGwJson',
                    label: 'commissionGwJson',
                    alignRight: false,
                    cell: 'CommissionsTotal',
                    from: 'publicCommissions',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true
                },
                {
                    id: 'totalAgentCommission',
                    label: 'totalAgentCommission',
                    alignRight: false,
                    cell: 'Amount',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true
                },
                {
                    id: 'totalIncludedCommission',
                    label: 'totalIncludedCommission',
                    alignRight: false,
                    cell: 'Amount',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true
                },
                {
                    id: 'totalIncludedCommissionGwCost',
                    label: 'totalIncludedCommissionGwCost',
                    alignRight: false,
                    cell: 'Amount',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true
                },
                {
                    id: 'totalOntopCommission',
                    label: 'totalOntopCommission',
                    alignRight: false,
                    cell: 'Amount',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true
                },
                {
                    id: 'totalOntopCommissionGwCost',
                    label: 'totalOntopCommissionGwCost',
                    alignRight: false,
                    cell: 'Amount',
                    // total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true
                },
                {
                    id: 'originalPaymentId',
                    label: 'originalPaymentId',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'state',
                    label: 'state',
                    alignRight: false,
                    cell: 'State',
                    items: ['processed', 'refused', 'awaiting_3ds'],
                    displayGrid: true
                },
                {
                    id: 'stateDesc',
                    label: 'stateDesc',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'internalStateDescription',
                    label: 'internalStateDescription',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'gatewayTransactionId',
                    label: 'gatewayTransaction',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'terminalCurrency',
                    label: 'terminalCurrency',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'convertedAmount',
                    label: 'convertedAmount',
                    alignRight: false,
                    cell: 'Conversion',
                    conversionFields: [
                        'conversionRate',
                        'convertedAmount',
                        'gatewayCurrency'
                    ], // 1: rate, 2: amount, 3: currency
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'requestedAmount',
                    label: 'requestedAmount',
                    alignRight: false,
                    cell: 'Conversion',
                    conversionFields: [
                        'requestConversionRate',
                        'requestConvertedAmount',
                        'requestCurrency'
                    ], // 1: rate, 2: amount, 3: currency
                    variant: 'reversed', // 'default' or 'reversed'
                    displayGrid: true,
                    disableEditor: true,
                    customSort: 'requestConvertedAmount'
                },
                {
                    id: 'callbackUrl',
                    label: 'callbackUrl',
                    alignRight: false,
                    cell: 'Text',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'payload',
                    label: 'payload',
                    alignRight: false,
                    cell: 'Text',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    customLogicOnMount = async () => {
        const endDate = new Date();
        const startDate = new Date(endDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        const lastWeek = formatDate(startDate, endDate);
        await this.dateRangeSave(lastWeek);
        const state = this.props.location?.state;
        const searchValue = state?.searchValue || '';
        if (searchValue) {
            await this.search(searchValue);
        }
    };


    renderCustomMenuItems() {
        return [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>,
            <MenuItem
                key="refreshStatus"
                onClick={(event) => this.handleRefreshStatus(event)}
            >
                <Update sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.refreshStatus')}
            </MenuItem>
        ];
    }
}
